import API_URL from '../config';
import { getAuthHeaders } from '../utils/api';
import { getLocalDateString } from '../utils/formatters';

// eslint-disable-next-line import/prefer-default-export
export const getLeaderboard = async (period = 'all-time', category = 'streaks') => {
  const localDate = getLocalDateString();
  const response = await fetch(
    `${API_URL}/api/leaderboard?period=${period}&category=${category}&date=${localDate}`,
    {
      headers: getAuthHeaders(),
    },
  );
  if (!response.ok) {
    throw new Error('Failed to fetch leaderboard');
  }
  return response.json();
};
